<ng-container>
  <h2 class="text-tertiary d-flex justify-content-between uppercase">
    <span mat-dialog-title>{{data.title}}</span>
    <button
    mat-dialog-close
    class="close"
    mat-icon-button
    >
      <mat-icon class="icon-cross"></mat-icon>
    </button>
  </h2>
  <form [formGroup]="historicalForm">
  <mat-dialog-content class="mat-typography">
  <p role="alert" class="text-secondary center title-10 text-w-500 mt-2">{{multilingualService.langMap?.LABEL_REQUEST_HISTORICAL_DATA_MESSAGE }}
  </p>
    <div class="form-group mb-2">
      <label for="selectYear">{{multilingualService.langMap?.LABEL_REQUEST_HISTORICAL_DATA_FOR_SELECT_YEAR}}
        <span class="text-primary text-w-600">*</span>
      </label>
      <div class="select-box">
        <select  formControlName="year" class="form-control" placeholder="Select Year">
          <option *ngFor="let year of data.range" [value]="year">
              {{ year }}
          </option>
        </select>
        <span *ngIf="this.historicalForm.get('year')?.errors?.required && this.historicalForm.get('year')?.touched"
        class="text-danger">{{multilingualService.langMap?.LABEL_SELECT_YEAR_REQUIRED_MESSAGE}}</span>
      </div>
    </div>
    <div class="form-group mb-2">
      <label for="textarea" >{{multilingualService.langMap?.LABEL_REQUEST_HISTORICAL_DATA_FOR_REASON}}
        <span class="text-primary text-w-600">*</span>
      </label>
      <textarea  formControlName="reason" id="other-textarea" maxlength="1000" type="text" 
        class="form-control comments"></textarea>
        <span *ngIf="this.historicalForm.get('reason')?.errors?.required && this.historicalForm.get('reason')?.touched"
        class="text-danger">{{multilingualService.langMap?.LABEL_ENTER_REASON_REQUIRED_MESSAGE}}</span>
    </div>

  </mat-dialog-content>
<mat-dialog-actions align="center" class="no-margin mb-2">
  <button
    mat-raised-button
    class="primary-button title-11 mb-2"
    [disabled]="historicalForm.invalid" (click)="request();" 
  >
  {{multilingualService.langMap?.LABEL_REQUEST_HISTORICAL_DATA_BUTTON }}
  </button>
  <button
    mat-stroked-button
    (click)="cancel();" 
    class="secondary-button mb-2 title-11"
  >
  {{multilingualService.langMap?.LABEL_REQUEST_HISTORICAL_DATA_CANCEL_BUTTON }}

  </button>
</mat-dialog-actions>
</form>

</ng-container>